//# sourceMappingURL=connector.mjs.map
/// <reference types="./connector.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $order from "../../gleam_stdlib/gleam/order.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $uri from "../../gleam_stdlib/gleam/uri.mjs";
import { Ok, Error, toList, CustomType as $CustomType } from "../gleam.mjs";

export class GoogleDrive extends $CustomType {}
export const Connector$GoogleDrive = () => new GoogleDrive();
export const Connector$isGoogleDrive = (value) => value instanceof GoogleDrive;

export class Confluence extends $CustomType {}
export const Connector$Confluence = () => new Confluence();
export const Connector$isConfluence = (value) => value instanceof Confluence;

export class Salesforce extends $CustomType {}
export const Connector$Salesforce = () => new Salesforce();
export const Connector$isSalesforce = (value) => value instanceof Salesforce;

export class Website extends $CustomType {}
export const Connector$Website = () => new Website();
export const Connector$isWebsite = (value) => value instanceof Website;

export class Notion extends $CustomType {}
export const Connector$Notion = () => new Notion();
export const Connector$isNotion = (value) => value instanceof Notion;

export class OneDrive extends $CustomType {}
export const Connector$OneDrive = () => new OneDrive();
export const Connector$isOneDrive = (value) => value instanceof OneDrive;

export class Slack extends $CustomType {}
export const Connector$Slack = () => new Slack();
export const Connector$isSlack = (value) => value instanceof Slack;

export class Steerlab extends $CustomType {}
export const Connector$Steerlab = () => new Steerlab();
export const Connector$isSteerlab = (value) => value instanceof Steerlab;

export class SteerlabQna extends $CustomType {}
export const Connector$SteerlabQna = () => new SteerlabQna();
export const Connector$isSteerlabQna = (value) => value instanceof SteerlabQna;

export class SteerlabProposal extends $CustomType {}
export const Connector$SteerlabProposal = () => new SteerlabProposal();
export const Connector$isSteerlabProposal = (value) =>
  value instanceof SteerlabProposal;

export const excluded = /* @__PURE__ */ toList([
  /* @__PURE__ */ new Steerlab(),
  /* @__PURE__ */ new SteerlabQna(),
  /* @__PURE__ */ new SteerlabProposal(),
  /* @__PURE__ */ new Website(),
]);

export function to_string(connector) {
  if (connector instanceof GoogleDrive) {
    return "google-drive";
  } else if (connector instanceof Confluence) {
    return "confluence";
  } else if (connector instanceof Salesforce) {
    return "salesforce";
  } else if (connector instanceof Website) {
    return "website";
  } else if (connector instanceof Notion) {
    return "notion";
  } else if (connector instanceof OneDrive) {
    return "one-drive";
  } else if (connector instanceof Slack) {
    return "slack";
  } else if (connector instanceof Steerlab) {
    return "steerlab";
  } else if (connector instanceof SteerlabQna) {
    return "steerlab-qna";
  } else {
    return "steerlab-proposal";
  }
}

export function format(connector) {
  if (connector instanceof GoogleDrive) {
    return "Google Drive";
  } else if (connector instanceof Confluence) {
    return "Confluence";
  } else if (connector instanceof Salesforce) {
    return "Salesforce";
  } else if (connector instanceof Website) {
    return "Website";
  } else if (connector instanceof Notion) {
    return "Notion";
  } else if (connector instanceof OneDrive) {
    return "Microsoft OneDrive";
  } else if (connector instanceof Slack) {
    return "Slack";
  } else if (connector instanceof Steerlab) {
    return "Steerlab";
  } else if (connector instanceof SteerlabQna) {
    return "Steerlab Q&A";
  } else {
    return "Steerlab Proposal";
  }
}

export function from_string(connector) {
  if (connector === "google-drive") {
    return new Ok(new GoogleDrive());
  } else if (connector === "confluence") {
    return new Ok(new Confluence());
  } else if (connector === "salesforce") {
    return new Ok(new Salesforce());
  } else if (connector === "website") {
    return new Ok(new Website());
  } else if (connector === "notion") {
    return new Ok(new Notion());
  } else if (connector === "one-drive") {
    return new Ok(new OneDrive());
  } else if (connector === "slack") {
    return new Ok(new Slack());
  } else if (connector === "steerlab") {
    return new Ok(new Steerlab());
  } else if (connector === "steerlab-qna") {
    return new Ok(new SteerlabQna());
  } else if (connector === "steerlab-proposal") {
    return new Ok(new SteerlabProposal());
  } else {
    return new Error(undefined);
  }
}

export function encode(connector) {
  return $json.string(to_string(connector));
}

export function decoder() {
  return $decode.then$(
    $decode.string,
    (str) => {
      let $ = from_string(str);
      if ($ instanceof Ok) {
        let connector = $[0];
        return $decode.success(connector);
      } else {
        return $decode.failure(new GoogleDrive(), "Connector");
      }
    },
  );
}

export function is_synchronised_integration(connector) {
  if (connector instanceof GoogleDrive) {
    return true;
  } else if (connector instanceof Confluence) {
    return true;
  } else if (connector instanceof Salesforce) {
    return true;
  } else if (connector instanceof Website) {
    return true;
  } else if (connector instanceof Notion) {
    return true;
  } else if (connector instanceof OneDrive) {
    return true;
  } else {
    return false;
  }
}

export function get_website_segment(url, index) {
  let $ = $uri.parse(url);
  if ($ instanceof Ok) {
    let u = $[0];
    let _pipe = u.path;
    let _pipe$1 = $string.split(_pipe, "/");
    let _pipe$2 = $list.drop(_pipe$1, 1);
    let _pipe$3 = $list.drop(_pipe$2, index);
    let _pipe$4 = $list.first(_pipe$3);
    return $result.unwrap(_pipe$4, "");
  } else {
    return "";
  }
}

export function get_domain(url) {
  let _pipe = $uri.parse(url);
  let _pipe$1 = $result.map(
    _pipe,
    (u) => { return $option.unwrap(u.host, url); },
  );
  return $result.unwrap(_pipe$1, url);
}

export function url_key_at_depth(url, depth) {
  let $ = depth === 0;
  if ($) {
    return get_domain(url);
  } else {
    return get_website_segment(url, depth - 1);
  }
}

function rank(c) {
  if (c instanceof Steerlab) {
    return 0;
  } else if (c instanceof SteerlabQna) {
    return 1;
  } else if (c instanceof SteerlabProposal) {
    return 2;
  } else {
    return 3;
  }
}

/**
 * Compare two connectors. Returns in priority Steerlab, SteerlabQna and
 * SteerlabProposal in this order, and then all others in alphabetical order.
 */
export function compare(c1, c2) {
  let $ = $int.compare(rank(c1), rank(c2));
  if ($ instanceof $order.Eq) {
    return $string.compare(format(c1), format(c2));
  } else {
    return $;
  }
}
